<template>
  <div class="job-shift-rotation">
    <p class="job-shift-rotation__label">{{ content }}</p>
  </div>
</template>

<script>
export default {
  computed: {
    content() {
      const arr = []
      if (this.isShiftRequired) {
        arr.push(this.$t('jobDetail.rotationShift'))
      }
      if (this.isAlternativeSat) {
        arr.push(this.$t('jobDetail.saturdayRequired'))
      }
      return arr.join(', ')
    },
  },
  props: {
    isAlternativeSat: {
      default: false,
      type: Boolean,
    },
    isShiftRequired: {
      default: false,
      type: Boolean,
    },
  },
}
</script>

<style lang="postcss" scoped>
.job-shift-rotation {
  @apply flex items-center;
}
.job-shift-rotation__label {
  @apply flex-grow;
}
</style>
